export const columns = [
    { key: 'index', label: '번호', thStyle: { width: '60px' } },
    { key: 'code', label: '코드' },
    { key: 'version', label: '버전', thStyle: { width: '70px' } },
    { key: 'label', label: '라벨' },
    { key: 'description', label: '설명' },
    { key: 'detail', label: '상세', thStyle: { width: '80px' } },
    { key: 'updated_at', label: '수정일시', thStyle: { width: '180px' } },
];
